// @mui
import type { PopoverOrigin } from '@mui/material';

import { Popover } from '@mui/material';

import type { MenuPopoverProps } from './types';

//
import getPosition from './getPosition';
import { StyledArrow } from './styles';

const MenuPopover = ({
  arrow = 'top-right',
  children,
  disabledArrow,
  open,
  sx,
  ...other
}: MenuPopoverProps) => {
  const { anchorOrigin, style, transformOrigin } = getPosition(arrow);

  return (
    <Popover
      anchorEl={open}
      anchorOrigin={anchorOrigin as PopoverOrigin}
      open={Boolean(open)}
      PaperProps={{
        sx: {
          overflow: 'inherit',
          p: 1,
          width: 'auto',
          ...style,
          '& .MuiMenuItem-root': {
            '& svg': { flexShrink: 0, height: 20, mr: 2, width: 20 },
            borderRadius: 0.75,
            px: 1,
            typography: 'body2',
          },
          ...sx,
        },
      }}
      transformOrigin={transformOrigin as PopoverOrigin}
      {...other}
    >
      {!disabledArrow && <StyledArrow arrow={arrow} />}

      {children}
    </Popover>
  );
};

export default MenuPopover;
